export default __webpack_public_path__ + "static/media/tapngo.75c4e727.png";